@if (campus$ | async; as campus) {
	<section class="container">
		@if (campus && campus.locations && campus.locations.length > 0) {
			<div class="divider">
				<h2 class="secondary-header !mb-0">Campus Locations</h2>
				<uc-campus-card-navigation
					(selectIndex)="onSelectIndex($event)"
					[navigationItems]="navigationItems"
				/>
				@if (campus.locations[selectedIndex]; as location) {
					<uc-university-section-card
						[name]="location.name"
						componentName="Campus Locations"
						[description]="location.description"
						[image]="location.image"
						[product]="product"
						[externalUrl]="campus.external_url"
						[uniId]="uniId()"
						[uniName]="uniName()"
						[ugSearchOrderPosition]="ugSearchOrderPosition()"
					/>
				}
			</div>
		}
	</section>
}
